import { IUserContactPreference } from '@interlayer/js/hooks/user/store/buzz/types';

import {
    CONTACT_TYPES_FRONT,
    DEFAULT_MARKETING_PRODUCTS,
    MAIN_CONTACT_TYPES,
    MAIN_CONTACT_TYPES_FRONT,
    MARKETING_CHECKBOXES_FRONT,
    MARKETING_CHECKBOXES_IMS
} from './constants';
import { TMarketingTypesWithProduct } from './types';

const getPreferencesKeys = (products: string[]) => MAIN_CONTACT_TYPES_FRONT.reduce((acc: Array<string>, key) => {
    products.forEach((product) => acc.push(`${product}_${key}`));

    return acc;
}, []);

export const getContactPreferencesForSending = (
    marketingPrefers: TMarketingTypesWithProduct,
    products: Array<string> = DEFAULT_MARKETING_PRODUCTS
) =>
    getPreferencesKeys(products)
        .map(item => {
            const [product, channel] = item.split('_');

            return {
                product,
                channel: MARKETING_CHECKBOXES_FRONT[<CONTACT_TYPES_FRONT>channel].imsName,
                preference: Boolean(marketingPrefers[item]),
                type: 'promotional'
            };
        });

export const getContactPreferencesForFront = (contactPreferences?: IUserContactPreference[]) => {
    const filteredPreferences = contactPreferences?.filter(({ channel, type, product }) => {
        return channel && MAIN_CONTACT_TYPES.includes(channel) && type === 'promotional' && product;
    });

    let isAllContactChecked = Boolean(filteredPreferences?.length);

    const preferences = filteredPreferences
        ?.reduce((acc: TMarketingTypesWithProduct, { preference, channel, type, product }) => {
            if (channel && MAIN_CONTACT_TYPES.includes(channel) && type === 'promotional' && product) {
                acc[`${product}_${MARKETING_CHECKBOXES_IMS[channel].name}`] = Boolean(preference);

                isAllContactChecked = Boolean(isAllContactChecked && preference);
            }

            return acc;
        }, {}) || {};

    return {
        ...preferences,
        selectAll: isAllContactChecked
    };
};
